import { animate, AnimationMetadata, style } from '@angular/animations';
import { fadeIn } from './fade-in';
import { fadeOut } from './fade-out';
import { slideDown } from './slide-down';
import { slideInOut } from './slide-in-out';
import { slideUp } from './slide-up';
import { slideFromTop } from './slide-from-top';
import { rotate } from './rotate';
import { expansionPanelAnimation } from './expand-collapse';

export const animations = {
  empty: 'empty',
  slideUp: 'slideUp',
  slideDown: 'slideDown',
  slideIn: 'slideIn',
  slideOut: 'slideOut',
  slideInOut: 'slideInOut',
  slideFromTop: 'slideFromTop',
  rotate: 'rotate',
  fadeIn: 'fadeIn',
  fadeOut: 'fadeOut',
  leave: 'leave',
  enter: 'enter',
  void: 'void',
  expansionPanelAnimation: 'expansionPanelAnimation'
};

export const animationsMap: { [key: string]: AnimationMetadata | null } = {
  empty: null,
  undefined: null,
  fadeIn,
  fadeOut,
  slideDown,
  slideInOut,
  slideUp,
  slideFromTop,
  rotate,
  expansionPanelAnimation
};

export const triggerAnimationMap = {
  slideIn: 'slideOut',
  fadeOut: 'fadeOut',
  slideOut: 'slideIn',
  void: 'empty',
  empty: 'empty',
  slideDown: 'slideDown',
  slideUp: 'slideUp',
  slideInOut: 'slideInOut',
  slideFromTop: 'slideFromTop',
  rotate: 'rotate',
  fadeIn: 'fadeIn',
  leave: 'leave',
  enter: 'enter',
  expansionPanelAnimation: 'expansionPanelAnimation'
};
export const ANIMATION_TIME = 300;
export const mobileCloseAnimation = [animate(`${ANIMATION_TIME}ms ease-out`, style({ transform: 'translateY(100%)' }))];
export const desktopCloseAnimation = [animate(`${ANIMATION_TIME}ms ease-in`, style({ opacity: 0 }))];
export const mobileOpenAnimation = [style({ transform: 'translateY(100%)' }), animate(`${ANIMATION_TIME}ms ease-out`)];
export const desktopOpenAnimation = [
  style({ opacity: 0 }),
  animate(`${ANIMATION_TIME}ms ease-out`, style({ opacity: 1 }))
];
